import React, { useEffect, useState } from 'react'
import { useAppServices } from 'hook/services'
import Editor from 'components/editor'

const defaultForm = {
  heading: '',
  text: '',
}

const RemoveAccessModel = () => {
  const Service = useAppServices()
  const [recordId, setRecordId] = useState('')
  const [loading, setLoading] = useState(false)
  const [fetching, setFetching] = useState(false)
  const [message, setMessage] = useState({ type: '', text: '' })
  const [formData, setFormData] = useState(defaultForm)
  const [initialData, setInitialData] = useState(defaultForm)

  const getSetting = async () => {
    try {
      setFetching(true)
      const { response } = await Service.super_admin_settings.get()
      if (response?.success && response?.data) {
        const removeAccess = response.data.remove_access || {}
        const next = {
          heading: removeAccess.heading || '',
          text: removeAccess.text || '',
        }
        setRecordId(response.data._id || '')
        setFormData(next)
        setInitialData(next)
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Failed to load remove access settings' })
    } finally {
      setFetching(false)
    }
  }

  useEffect(() => {
    getSetting()
  }, [])

  const handleSave = async () => {
    try {
      setLoading(true)
      setMessage({ type: '', text: '' })
      const payload = {
        remove_access: {
          heading: formData.heading,
          text: formData.text,
        },
      }
      if (recordId) payload._id = recordId

      const { response } = await Service.super_admin_settings.update({ payload })
      if (response?.success) {
        setMessage({ type: 'success', text: 'Remove access settings saved successfully' })
        setInitialData(formData)
        setTimeout(() => setMessage({ type: '', text: '' }), 3000)
      } else {
        setMessage({ type: 'error', text: 'Failed to save remove access settings' })
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Something went wrong while saving settings' })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <style>{`
        .ra-container { padding: 24px; }
        .ra-title { font-size: 18px; font-weight: 600; margin-bottom: 16px; }
        .ra-card {
          background: #fff;
          border-radius: 12px;
          padding: 24px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
        }
        .ra-field { margin-bottom: 16px; }
        .ra-label { display: block; font-size: 13px; font-weight: 500; margin-bottom: 8px; }
        .ra-input {
          width: 100%;
          padding: 10px 12px;
          border-radius: 8px;
          border: 1px solid #d1d5db;
          font-size: 14px;
          outline: none;
        }
        .ra-input:focus {
          border-color: #2f80ed;
          box-shadow: 0 0 0 2px rgba(47, 128, 237, 0.15);
        }
        .ra-editor {
          border-radius: 8px;
          border: 1px solid #e5e7eb;
          overflow: hidden;
        }
        .ra-actions {
          display: flex;
          justify-content: flex-end;
          gap: 12px;
          margin-top: 24px;
        }
        .ra-btn {
          padding: 8px 14px;
          border-radius: 8px;
          border: none;
          cursor: pointer;
          font-size: 14px;
        }
        .ra-btn.secondary { background: #f3f4f6; }
        .ra-btn.primary { background: #2f80ed; color: #fff; }
        .ra-message {
          margin-bottom: 14px;
          padding: 10px 14px;
          border-radius: 8px;
          font-size: 14px;
        }
        .ra-message.success { background: #ecfdf5; color: #065f46; }
        .ra-message.error { background: #fee2e2; color: #991b1b; }
      `}</style>
      <div className="ra-container">
        <h2 className="ra-title">Remove Access Settings</h2>
        {fetching ? (
          <div>Loading...</div>
        ) : (
          <div className="ra-card">
            {message.text && <div className={`ra-message ${message.type}`}>{message.text}</div>}

            <div className="ra-field">
              <label className="ra-label">Heading</label>
              <input
                type="text"
                className="ra-input"
                placeholder="Enter remove access heading"
                value={formData.heading}
                onChange={(e) => setFormData((prev) => ({ ...prev, heading: e.target.value }))}
              />
            </div>

            <div className="ra-field">
              <label className="ra-label">Text</label>
              <div className="ra-editor">
                <Editor
                  data={formData.text}
                  handleChange={(value) => setFormData((prev) => ({ ...prev, text: value }))}
                />
              </div>
            </div>

            <div className="ra-actions">
              <button className="ra-btn primary" onClick={handleSave} disabled={loading}>
                {loading ? 'Saving...' : 'Save Changes'}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default RemoveAccessModel
